import { createRouter, createWebHistory } from "vue-router";
import Activate from "./components/Activate.vue";

// router.js
export function isLoggedIn() {
  const token = localStorage.getItem("token");
  if (!token) return false;

  try {
    const payloadJson = atob(token);
    const payload = JSON.parse(payloadJson);
    return payload.exp && Date.now() / 1000 < payload.exp;
  } catch (e) {
    return false;
  }
}

const routes = [
  {
    path: "/login",
    name: "LoginPage",
    component: () => import("./components/LoginPage.vue"),
  },
  {
    path: "/english",
    name: "English",
    component: () => import("./components/English.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/videoplayer",
    name: "VideoPlayer",
    component: () => import("./components/VideoPlayer.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/episode/:code",
    name: "Episode",
    component: () => import("./components/Episode.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/search",
    name: "Search",
    component: () => import("./components/Search.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/collection/entries",
    name: "Entries",
    component: () => import("./components/collection/Entries.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/collection/episodes",
    name: "Episodes",
    component: () => import("./components/collection/Episodes.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/collection/subtitles",
    name: "Subtitles",
    component: () => import("./components/collection/Subtitles.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/learningtechniques", //学习方法页面
    name: "Learningtechniques",
    component: () => import("./components/Learningtechniques.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/feedback", //反馈页面
    name: "Feedback",
    component: () => import("./components/Feedback.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/myprofile", //账号页面
    name: "Myprofile",
    component: () => import("./components/Myprofile.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/cebian", //侧边弹框筛选页面
    name: "Cebian",
    component: () => import("./components/Cebian.vue"),
    meta: { requiresAuth: true },
  },
  {
    path: "/activate/:code",
    name: "Activate",
    component: Activate,
  },
  {
    path: "/",
    redirect: "/login",
  },
];

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHistory('/English/'),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({ name: "LoginPage" });
  } else if (to.name === "LoginPage" && isLoggedIn()) {
    next({ name: "English" });
  } else {
    next();
  }
});

export default router;
